const FeaturedLists = (state = [
  {
    slug: 'luxury',
    title: 'ラグジュアリー',
    description: '気品を感じるセレクト',
    date: '2016.11.20',
    image: '/img/featured/luxury.jpg',
    items: []
  },
  {
    slug: 'outdoor',
    title: 'アウトドアライフ',
    description: '外に出かけたくなるチョイス',
    date: '2016.11.20',
    image: '/img/featured/outdoor.jpg',
    items: []
  },
], action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default FeaturedLists



// WEBPACK FOOTER //
// ./src/reducers/featuredLists.js